import Estatus from '../../componentes/Estatus';
import Listados from '../../contenedores/Listados';
import { TERMINALES } from "../../configuraciones/endpoints";

const cabeceros = [
  { label: 'Nombre', key: 'Nombre' },
  { label: 'Direccion ip', key: 'Ip'},
  { label: 'Puerto', key: 'Puerto'},
  { label: 'Empresa', transform: (row) => row.Sucursal?.Empresa?.Nombre || '' },
  { label: 'Sucursal', transform: (row) => row.Sucursal?.Nombre || '' },
  { label: 'Checadas', transform: ({ Checadas }) => Checadas || '0' },
  { label: 'Estatus', transform: ({ Habilitado }) => <Estatus activo={Habilitado} /> },
];

const Terminales = ({ history, location }) => {

  return <Listados
    titulo="Terminales"
    placeHolder="Búsqueda por nombre"
    history={history}
    location={location}
    showActions
    filtrosBusqueda={{
      btnAgragar: true,
    }}
    cabeceros={cabeceros || []}
    apiKey={TERMINALES}
  />;
};

export default Terminales;